import { IWorkResourceJobTitle } from "../common/data/dtos/work-resource-job-title";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/WorkResourceJobTitle';

interface WorkResourceJobTitleResponse {
    success: boolean;
    workResourceJobTitle?: IWorkResourceJobTitle;
    workResourcesJobTitle?: IWorkResourceJobTitle[];
    error?: string;
}

type CreateWorkResourceJobTitleType = Omit<IWorkResourceJobTitle, 'id'> | Partial<IWorkResourceJobTitle>;

const createWorkResourcesJobTitle = async (workResourcesJobTitle: CreateWorkResourceJobTitleType[]): Promise<WorkResourceJobTitleResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IWorkResourceJobTitle>(`${BASE_PATH}`, workResourcesJobTitle);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deleteWorkResourceJobTitle = async (id: string): Promise<WorkResourceJobTitleResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IWorkResourceJobTitle>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getWorkResourceJobTitleByJobTitle = async (id: string): Promise<WorkResourceJobTitleResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IWorkResourceJobTitle>(`${BASE_PATH}/GetByJobTitle?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, workResourcesJobTitle: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createWorkResourcesJobTitle,
    deleteWorkResourceJobTitle,
    getWorkResourceJobTitleByJobTitle
};